import React, { FC } from "react";
import { faPlus as faSolidPlus } from "@fortawesome/pro-solid-svg-icons/faPlus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const PlusSolid: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faSolidPlus} {...props} />
);
